<template>
    <q-banner v-if="$pwa?.needRefresh" class="bg-accent text-white" inline-actions>
        <template #avatar>
            <q-icon name="update" />
        </template>
        A new version of myLHS is available. Please save your work and reload the app.
        <div v-if="updateError" role="alert" class="text-negative">{{ updateError }}</div>
        <template #action>
            <q-btn
                outline
                icon="update"
                color="white"
                label="Reload app"
                :loading="updating"
                @click="updateApp"
            />
        </template>
    </q-banner>
</template>

<script setup>
    const { $pwa } = useNuxtApp();
    const updating = ref(false);
    const updateError = ref('');

    async function updateApp() {
        if (!$pwa?.needRefresh || updating.value) return;

        updating.value = true;
        updateError.value = '';
        try {
            await $pwa.updateServiceWorker(true);
        } catch {
            updateError.value = 'Unable to update. Please try again.';
        } finally {
            updating.value = false;
        }
    }
</script>
